export const BillcomHealthCheckNotificationsType = {
  BILLCOM_MANUAL_IMPORT_COMPLETED: 'BILLCOM_MANUAL_IMPORT_COMPLETED',
};
export const BillcomHealthCheckNotificationsWithCriticalSeverityLevel: string[] =
  [];
